/** Iter 44 — display-file (DSPF) field reference helpers. Pure, no React. */

export const SCREEN_KINDS = ["input", "output", "display"];

export const SCREEN_WORDING = {
  input: "input-capable screen field",
  output: "output/display field",
  display: "hidden / control screen field",
};

export const isScreenRef = (row) => Boolean(row?.display_file);

/** Wording for the File column of a display-file reference: mapped / ambiguous / none. */
export function screenMappingLabel(row) {
  if (!isScreenRef(row)) return null;
  if (row.file_name) {
    return { kind: "mapped", text: `${row.file_library ? `${row.file_library}/` : ""}${row.file_name}`, hint: "Database mapping proven by DDS REF / REFFLD." };
  }
  if (row.ambiguous) return { kind: "ambiguous", text: "ambiguous database mapping", hint: row.usage_context || "" };
  return { kind: "none", text: "no database mapping", hint: row.usage_context || "" };
}

/** "4 input-capable · 9 output/display · 3 hidden / control" — counts only for kinds that occur. */
export function screenSummaryLine(screen) {
  if (!screen) return "";
  const parts = [];
  if (screen.input) parts.push(`${screen.input} input-capable`);
  if (screen.output) parts.push(`${screen.output} output/display`);
  if (screen.display) parts.push(`${screen.display} hidden / control`);
  return parts.join(" · ");
}

export const screenLabel = (kind, n = 1) => `${SCREEN_WORDING[kind] || "screen field"}${n === 1 ? "" : "s"}`;
